export default {
  namespaced: true,
  profiles: {
    title: "profile | profiles",
    description: "description",
    forced_layouts: "forced layouts",
    session_time:"Session time in hours",
    priority:"PTZ control priority",
    priority_helper:"Lower numbers mean higher priority.",
    inactivity_lifetime: "Inactivity life time in minutes",
    clone_title: "Clone profile",
    new_name: "New name",
    clone_success: "Profile cloned successfully",
  },
};
